import axios from 'axios';

const getHeaders = () => {
    return {
        "Accept": "application/json",
        "Content-Type": "application/json; charset=utf-8"
    };
};

// In development, use proxy (empty baseURL or '/api')
// In production, use relative paths (Netlify proxy) or direct URL if HTTPS is available
const isDevelopment = process.env.NODE_ENV === 'development';

let baseURL;
if (isDevelopment) {
    // Use proxy in development
    baseURL = '/api';
} else {
    // In production:
    // - If frontend is on Netlify, use relative paths (Netlify proxy handles it)
    // - If backend has HTTPS, use direct URL from environment variable
    const apiBaseUri = process.env.REACT_APP_API_BASE_URI;
    
    // Check if backend URL uses HTTPS
    if (apiBaseUri && apiBaseUri.startsWith('https://')) {
        // Backend has HTTPS - use direct URL
        const cleanUri = apiBaseUri.replace(/\/+$/, '').replace(/\/api\/?$/, '');
        baseURL = `${cleanUri}/api`;
    } else {
        // Backend uses HTTP - use relative paths (Netlify proxy will handle it)
        // Or if not on Netlify, this will use same origin
        baseURL = '/api';
    }
}

export default axios.create({
    baseURL: baseURL,
    headers: getHeaders(),
});
